module.exports = __webpack_public_path__ + "img/placeList1.28a8ce64.png";